import { Component, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { SeConstraintNotifierService } from '@se/constraint';
import { Logger } from '@se/se.ui.html5';

import { AbstractControlComponent } from '../abstract-control';

@Component({
    selector: 'cp-placeholder',
    templateUrl: './placeholder.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpPlaceholderComponent extends AbstractControlComponent {
    constructor(cdr: ChangeDetectorRef, constraintNotifierService: SeConstraintNotifierService, logger: Logger) {
        super(cdr, constraintNotifierService, logger);
    }

    protected onModelChange() {
        return false;
    }

    protected init() {
        // Nulla da fare.
    }
}
